import Glider from 'glider-js';
import { FunctionComponent, h } from 'preact';
import { useEffect, useLayoutEffect, useRef, useState } from 'preact/hooks';
import classnames from 'classnames';

import { useWindowSize } from '../../hooks';

import { IconCaretLeft, IconCaretRight } from '../icons';

const Circle: FunctionComponent = ({ children }) => (
    <div className="u-circle u-bg-white dark:u-bg-pink-100 l-square l-square--fixed u-font-4 u-mx-1">
        <div className="u-txt-pink-100 dark:u-txt-white l-square__inner">{children}</div>
    </div>
);

type Props = {
    className?: string;
};

export const Carousel: FunctionComponent<Props> = (props) => {
    const slides = useRef<HTMLDivElement | null>(null);
    const dots = useRef<HTMLDivElement | null>(null);
    const size = useWindowSize();
    const [navVisible, setNavVisible] = useState(true);
    const glider = useRef<Glider | null>(null);

    useEffect(() => {
        if (!slides.current) {
            return;
        }

        glider.current = new Glider(slides.current, {
            draggable: true,
            slidesToShow: 1.2,
            slidesToScroll: 1,
            dots: '.js-dots',
            duration: 0.25,
            arrows: {
                prev: '.js-prev',
                next: '.js-next',
            },
            responsive: [
                {
                    breakpoint: 700,
                    settings: {
                        scrollLock: true,
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 1100,
                    settings: {
                        scrollLock: true,
                        slidesToShow: 3,
                    },
                },
            ],
        });

        return () => glider.current && glider.current.destroy();
    }, []);

    useLayoutEffect(() => {
        glider.current && glider.current.refresh(true);
        dots.current && setNavVisible(dots.current.childNodes.length > 1);
    }, [size]);

    return (
        <div className={classnames('glider-contain', props.className)}>
            <div ref={slides} className="c-slides">
                {props.children}
            </div>

            <div className="glider-controls" hidden={!navVisible}>
                <button aria-label="Previous" className="js-prev glider-prev">
                    <Circle>
                        <IconCaretLeft width="30" height="30" className="" />
                    </Circle>
                </button>
                <div ref={dots} role="tablist" className="js-dots" />
                <button aria-label="Next" className="js-next glider-next">
                    <Circle>
                        <IconCaretRight width="30" height="30" className="" />
                    </Circle>
                </button>
            </div>
        </div>
    );
};
